import "./App.css";
import AllRoutes from "./Pages/AllRoutes/AllRoutes";

function App() {
  return <AllRoutes />;
}

export default App;
